module.exports = __webpack_public_path__ + "static/media/portfolio11.3b30f236.png";